'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_ObserverList$() {
}
export { $c_Lcom_raquo_airstream_core_ObserverList$ as $c_Lcom_raquo_airstream_core_ObserverList$ };
$p = $c_Lcom_raquo_airstream_core_ObserverList$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_ObserverList$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_ObserverList$() {
}
export { $h_Lcom_raquo_airstream_core_ObserverList$ as $h_Lcom_raquo_airstream_core_ObserverList$ };
$h_Lcom_raquo_airstream_core_ObserverList$.prototype = $p;
$p.PW = (function(this$, observer) {
  var index = (this$.indexOf(observer) | 0);
  var shouldRemove = (index !== (-1));
  if (shouldRemove) {
    this$.splice(index, 1);
  }
  return shouldRemove;
});
var $d_Lcom_raquo_airstream_core_ObserverList$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_ObserverList$, "com.raquo.airstream.core.ObserverList$", ({
  gN: 1
}));
export { $d_Lcom_raquo_airstream_core_ObserverList$ as $d_Lcom_raquo_airstream_core_ObserverList$ };
var $n_Lcom_raquo_airstream_core_ObserverList$;
function $m_Lcom_raquo_airstream_core_ObserverList$() {
  if ((!$n_Lcom_raquo_airstream_core_ObserverList$)) {
    $n_Lcom_raquo_airstream_core_ObserverList$ = new $c_Lcom_raquo_airstream_core_ObserverList$();
  }
  return $n_Lcom_raquo_airstream_core_ObserverList$;
}
export { $m_Lcom_raquo_airstream_core_ObserverList$ as $m_Lcom_raquo_airstream_core_ObserverList$ };
